import { useTLang } from 'intl/intl';

export function useSOListSkeletonLang() {
  return {
    loadingLabel: useTLang({ id: 'scheduleOrder.loadingLabel' }),
  };
}
